import React from 'react';

import { inject, observer } from 'mobx-react';
import { action, computed, observable } from 'mobx';

import Icon from 'bz-icons/src/controls/icon';

import GUID from 'bz-utilities/modules/variables/guid';
import featureFlag from 'tm3-core/stores/feature-store';
import EmptyMessage from './controls/empty-message';

import ErrorMessage from './controls/error-message';
import AttachmentTable from './controls/attachment-table';
import LoadingSlider from 'bz-core-controls/controls/layout/loading-slider';

import './style.styl';

import { Button } from '@material-ui/core';

@inject('clinicalStore')
@observer
class Attachments extends React.Component {
  @observable expand = !!this.props.viewable;

  render() {
    if (!this.show) return null;

    return (
      <div className={this.className}>
        <div className={'clinical-page-header'}>
          <div className="nowrap flex-row" onClick={this.onOpen}>
            <div className="flex-none">
              <Button disabled={this.loading} style={{ minWidth: 36 }}>
                <Icon width={18} height={18} value="0001_back_left_arrow" />
              </Button>
            </div>
            <div className="flex-both">
              <h1>Referral Attachments</h1>
            </div>
          </div>
        </div>
        <LoadingSlider loading={this.loading}>
          <div className="clinical-page-content">
            <AttachmentTable />
            <EmptyMessage />
            <ErrorMessage />
          </div>
        </LoadingSlider>
      </div>
    );
  }

  @computed
  get show() {
    const { caseStore } = this.props.clinicalStore;
    const { bookingAuditId = '' } = caseStore.details;
    let { attachments, reports } = this.props.clinicalStore.prontoStore;
    return (
      featureFlag.prontoIntegrationEnabled &&
      GUID.hasValue(bookingAuditId) &&
      attachments.length > 0
    );
  }

  @computed
  get loading() {
    let { status } = this.props.clinicalStore.prontoStore;
    return status === 'pending';
  }

  @computed
  get expanded() {
    let { navKey, clinicalStore } = this.props;
    let { status } = clinicalStore.prontoStore;
    if (status !== 'fullfilled') return false;
    return this.expand || clinicalStore.activePageKeys.indexOf(navKey) > -1;
  }

  @computed
  get className() {
    let open = !!this.expanded ? 'open' : '';
    return `clinical-page pronto-attachments ${open}`;
  }

  @action.bound
  onOpen() {
    const navKey = 'pronto-attachments';
    let { clinicalStore } = this.props;

    if (clinicalStore.activePageKeys.indexOf(navKey) > -1) {
      this.expand = false;
      clinicalStore.setActivePageKey(navKey, true);
    } else {
      this.expand = !this.expand;
    }
  }
}

export default Attachments;
